import type { FaireProductEntity } from "../../entity_types/product";

export const p_jra53kwdw9: FaireProductEntity = {
  token: "p_jra53kwdw9",
  type: "product",
  name: "Sultry Legging: Silver Fog Gingham Plaid",
  brandToken: "b_66y0zxfe0m",
  brandName: "Glyder",
  imageUrl:
    "https://cdn.faire.com/fastly/919ec6b2e048cba9c436f183965f3a1450b5850b3d736236df3987226fb78fa5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6353ba192528e681bd48515e741743d67279246e3c94d15e700c2fce3b7e164.jpeg",
    "https://cdn.faire.com/fastly/a316eb99b1e5720d9a3dff703fb924675178a29448553904305f9659b97da1c2.jpeg",
    "https://cdn.faire.com/fastly/37e21d2bae585083667bcd6b82b8a47998c9f17eb35e99b5208ccdc9a48a6e36.jpeg",
  ],
  priceDollars: 38,
  description:
    "Perfectly place v-shaped seaming amplifies shape and lift on these sleek, figure-enhancing leggings, sculpting your bum almost as well as all those squats you've been doing. Complimented with a high waistband and a checkered design, these leggings maximize confidence and comfort.",
  tags: [],
  msrpDollars: 76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:03.718Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
